export default "__VITE_ASSET__6d17ff5b__"